import React, { forwardRef } from 'react';
import { Icon } from '@chakra-ui/react';
import { QIconProps } from './Icon';
import cls from './QualioAiAnimated.module.css';

export const QualioAIAnimated = forwardRef<SVGSVGElement, Partial<QIconProps>>(
  (props, ref) => {
    return (
      <Icon viewBox="0 0 24 24" color="currentColor" {...props} ref={ref}>
        <svg
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <g fill="currentColor">
            {/* stars */}
            <g className={`${cls.star} ${cls.s1}`}>
              <path d="M18.676 3.226c.111-.301.537-.301.648 0a4.15 4.15 0 0 0 2.45 2.45c.301.111.301.537 0 .648a4.15 4.15 0 0 0-2.45 2.45c-.111.301-.537.301-.648 0a4.15 4.15 0 0 0-2.45-2.45.346.346 0 0 1 0-.648 4.15 4.15 0 0 0 2.45-2.45Z" />
            </g>
            <g className={`${cls.star} ${cls.s2}`}>
              <path d="M15.568 14.301c.148-.401.716-.401.864 0a5.53 5.53 0 0 0 3.267 3.267c.401.148.401.716 0 .864a5.53 5.53 0 0 0-3.267 3.267c-.148.401-.716.401-.864 0a5.53 5.53 0 0 0-3.267-3.267c-.401-.148-.401-.716 0-.864a5.53 5.53 0 0 0 3.267-3.267Z" />
            </g>
            <g className={`${cls.star} ${cls.s3}`}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.374 10.585a9 9 0 0 0-.885-.383c-.652-.241-.652-1.163 0-1.404a9 9 0 0 0 .885-.383l.018-.009a9 9 0 0 0 4.014-4.014l.009-.018a9 9 0 0 0 .383-.885c.241-.652 1.163-.652 1.404 0a9 9 0 0 0 .455.981 9 9 0 0 0 3.969 3.945 9 9 0 0 0 .885.383c.652.241.652 1.163 0 1.404a9 9 0 0 0-.903.392 9 9 0 0 0-4.014 4.014l-.009.018a9 9 0 0 0-.383.885c-.241.652-1.163.652-1.404 0a9 9 0 0 0-4.406-4.917l-.018-.009ZM4.481 9.5A11 11 0 0 1 7.5 12.519 11 11 0 0 1 10.519 9.5 11 11 0 0 1 7.5 6.481 11 11 0 0 1 4.481 9.5Z"
              />
            </g>

            {/* dots: split out from the single path */}
            {/* centers chosen to match the original path’s circles*/}
            <circle className={`${cls.dot} ${cls.d1}`} cx="7" cy="22" r="1" />
            <circle className={`${cls.dot} ${cls.d2}`} cx="2" cy="18" r="1" />
            <circle className={`${cls.dot} ${cls.d3}`} cx="13" cy="2" r="1" />
            <circle className={`${cls.dot} ${cls.d4}`} cx="22" cy="13" r="1" />
          </g>
        </svg>
      </Icon>
    );
  },
);

QualioAIAnimated.displayName = 'QualioAI_Animated';
